export const SET_SHOW_UPLOAD_MEDIAS_DIALOG = 'SET_SHOW_UPLOAD_MEDIAS_DIALOG';

export const setShowUploadMediasDialog = (showUploadMediasDialog) => ({
	type: SET_SHOW_UPLOAD_MEDIAS_DIALOG,
	showUploadMediasDialog,
});
